module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Author-Note"
    }
  }, [_c('h2', {
    staticClass: "fm-title1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("A Note from the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I know what it’s like to be unseen, unheard, and unhappy. I know what it’s like to feel so much and have so much to say but you can’t find the words to express what you are going through. I know what it’s like to feel tired, a deep fatigue preventing you from absorbing joy. It’s lonely. But you are not alone. We’re in this together.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The good news is that you’ve survived 100 percent of your toughest days and I will get you through the rest.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container-r"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/sin.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe451bcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Author-Note.vue
// module id = 72
// module chunks = 0